// extracted by mini-css-extract-plugin
module.exports = {"survey":"styles_survey__ROgJi"};